import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useSnapshot } from "valtio";
import { useSelector } from "react-redux";

import { capitalize } from "@helpers/general";
import { getUuidUser } from "@helpers/getUuidUser";
import { store } from "@components/VerticalLayout/store";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

import { useFetchGlobal } from "../../../../../api/hooks";

import { RootState } from "../../../../../redux/store";

import { associateFranchiseFidelityToShop } from "./associateFidelity";

type Props = {
    isModalOpened: boolean;
    setIsModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
    setDataIsUpdated: React.Dispatch<React.SetStateAction<boolean | number>>;
    data: Record<string, FidelityPayload>;
    setDesignation: (v: string) => void;
    setChoiceFidelity: (v: string) => void;
    setAuthenticationMode: (v: string[]) => void;
    setIsAddFidelityClicked: (v: boolean) => void;
};

export function ConfirmationAssociationModalWrapper({
    isModalOpened,
    setIsModalOpened,
    data,
    setDesignation,
    setChoiceFidelity,
    setAuthenticationMode,
    setIsAddFidelityClicked,
}: Props) {
    const { t } = useTranslation();
    const isArchived = useSelector((s: RootState) => s.fidelity.isArchived);
    const { franchiseID, userID, shopID, operatorID } = useSnapshot(store);
    const { fetchGlobal } = useFetchGlobal();
    const uuidUser = getUuidUser();

    const close = () => setIsModalOpened(!isModalOpened);

    const handleValidate = () => {
        if (!isArchived) {
            associateFranchiseFidelityToShop({
                data,
                userID,
                franchiseID,
                shopID,
                operatorID,
                uuidUser,
                fetchGlobal,
                setDesignation,
                setChoiceFidelity,
                setAuthenticationMode,
                setIsAddFidelityClicked,
                t,
            });
        }
        setIsModalOpened(!isModalOpened);
    };

    const message = !isArchived
        ? t(
              "The fidelity settings already exist in the franchise. Would you like to associate it with this store?"
          )
        : t(
              "Attention ! the fidelity settings is already archived at the franchise level"
          );

    return (
        <StyledModal toggle={true} isOpen={isModalOpened} centered>
            <ModalHeader className="text-capitalize" toggle={close}>
                <span>{capitalize(t("Alert"))}</span>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {message}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                {!isArchived && (
                    <CustomSecondaryColorButton
                        outline
                        variant="light"
                        onClick={close}
                        rounded
                    >
                        {t("Cancel")}
                    </CustomSecondaryColorButton>
                )}
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={handleValidate}
                >
                    {!isArchived ? t("Validate") : t("Ok")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
